import React, { useState, useEffect } from 'react';
import MiniWidget from './MiniWidget';
import { Box } from 'grommet';
import { MasterCapabilitiesList } from '../utils/LMConstants';
import { formatShotData, detectDeviceType, getAllMeasurementsForLMInfo } from '../utils/Utilities';
import { WidgetButtonIcon } from '../icons/Icons';
import { USER_PREFERENCES_IMPORTED_EVENT } from '../utils/userPreferences';

// Define a constant to control the number of widgets displayed
const LOCAL_STORAGE_KEY = 'favoriteWidgets';

function MiniWidgets({ currentSetup, currentShot, key }) {
    const [widgetsData, setWidgetsData] = useState([]);
    const [isMobile, setIsMobile] = useState(detectDeviceType() === "Mobile");

    const [summaryValues, SetSummaryValues] = useState([]);

    useEffect(() => {
        updateSummaryValues();
        updateWidgetsData();

        return () => {
            setWidgetsData([]);
        };
    }, [currentSetup, currentShot, key]);

    useEffect(() => {
        updateSummaryValues();
        updateWidgetsData();
    }, [currentSetup]);

    useEffect(() => {
        updateWidgetsData();
    }, [summaryValues]) ;

    useEffect(() => {
        setIsMobile(detectDeviceType() === "Mobile");
      }, []);

    useEffect(() => {
        const handleImportedPreferences = () => {
            updateWidgetsData();
        };

        window.addEventListener(USER_PREFERENCES_IMPORTED_EVENT, handleImportedPreferences);
        return () => {
            window.removeEventListener(USER_PREFERENCES_IMPORTED_EVENT, handleImportedPreferences);
        };
    }, [currentShot, summaryValues]);

    function updateWidgetsData() {
        const savedWidgetIds = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
        let widgetsToAdd = [];

        savedWidgetIds.forEach((widgetId) => {
            if (typeof widgetId === 'string') {
                const [lmType, key] = widgetId.split('$');
                const lminfo = currentShot?.LMInfos.find(info => info.LMType === lmType);
                const measurements = getAllMeasurementsForLMInfo(lminfo);

                let dispName = MasterCapabilitiesList.find((l) => l.key === key)?.display || key;
                let dispUnit = MasterCapabilitiesList.find((l) => l.key === key)?.unit || '';
                let dispValue = '--';

                if (measurements[key] !== undefined) {
                    dispValue = measurements[key];
                    const isNaNOrMissing = dispValue === undefined || dispValue === null || Number.isNaN(dispValue) || dispValue === "NaN";

                    if (!isNaNOrMissing && dispValue) {
                        dispValue = formatShotData(key, dispValue);
                    } else {
                        dispValue = "--";
                    }
                }

                const sumValue = summaryValues.find(s => s.key === widgetId);
                
                let avg = '--';
                let std = '--';
                if (sumValue) {
                    const key = sumValue.key.split('$')[1];
                    const avgFull = sumValue.value / sumValue.count;
                    avg = formatShotData(key, avgFull, true);
                    const stdFull = standardDeviation(sumValue.values);
                    std = formatShotData(key, stdFull, true);
                }

                widgetsToAdd.push({
                    id: widgetId,
                    value: dispValue,
                    title: dispName,
                    unit: dispUnit,
                    avg,
                    std,
                    launchmonitor: lmType,
                });
            }
        });

        setWidgetsData(widgetsToAdd);
    }

    function updateSummaryValues() {
            SetSummaryValues([]);
            let summary = [];
            if (currentSetup && currentSetup.Shots && currentSetup.Shots.length > 0) {
                for (let i = 0; i < currentSetup.Shots.length; i++) {
                    const shot = currentSetup.Shots[i];
                    for (let j = 0; j < shot.LMInfos.length; j++) {
                        const lminfo = shot.LMInfos[j];
                        const measurements = getAllMeasurementsForLMInfo(lminfo);
                        for (let key in measurements) {
                            const newKey = lminfo.LMType + '$' + key;
                            const value =
                                measurements[key] === 'NaN'
                                    ? measurements[key]
                                    : formatShotData(key, measurements[key]);
                            if (shot.IsChecked) {
                                summary = AddItemToAvg(newKey, value, summary);
                            }
                        }
                    }
                }
            }
            SetSummaryValues(summary);
        }
    
    function AddItemToAvg(key, value, existingAvg) {
        let avgData = existingAvg;// ? existingAvg : [];
        let existingItem = avgData.find(item => item.key === key);
        const isNaNOrMissing =
            value === undefined ||
            value === null ||
            Number.isNaN(value) ||
            value === 'NaN' ||
            Number(value) === -99999;
        if (!isNaNOrMissing) {
            if (existingItem) {
                existingItem.value += Number(value);
                existingItem.count += 1;
                existingItem.values.push(Number(value));
            } else {
                avgData.push({ key: key, value: Number(value), values: [Number(value)], count: 1 });
            }
            // SetColumnAvgs(avgData);
            return avgData;
        } else {
            return existingAvg;
        }
    }

    function standardDeviation(numbers, isSample = true) {
    let n = numbers.length;
    if (n === 0) return 0; // Prevent division by zero
    
    // Step 1: Calculate mean
    let mean = numbers.reduce((acc, val) => acc + val, 0) / n;

    // Step 2: Calculate squared differences
    let squaredDiffs = numbers.map(num => Math.pow(num - mean, 2));

    // Step 3: Calculate variance
    let variance = squaredDiffs.reduce((acc, val) => acc + val, 0) / (isSample ? n - 1 : n);

    // Step 4: Return standard deviation (sqrt of variance)
    return Math.sqrt(variance);
};

    return (
        <>
            {/* {(widgetsData.length === 0 && !isMobile ) && (
                <div style={{height:'40px', width:'100%', display:'flex', flexDirection:'row', justifyContent:'center'}}>
                    <button className='desktop-mini-widgets-empty-button'>
                        <WidgetButtonIcon width='30px' height='30px' className='desktop-mini-widgets-empty-button-icon'/>
                        <span className='desktop-mini-widgets-empty-button-text'>Widgets</span>
                    </button>
                </div>
            )} */}
            {widgetsData.length > 0 && (
                <Box wrap={false} direction="row" overflow="auto" pad="0px" justify="center">
                {widgetsData.map((widget) => (
                    <Box key={widget.id} flex={false}>
                        <MiniWidget
                            id={widget.id}
                            title={widget.title}
                            value={widget.value}
                            unit={widget.unit}
                            std={widget.std}
                            avg={widget.avg}
                            launchmonitor={widget.launchmonitor}
                        />
                    </Box>
                ))}
            </Box>
            )}
        </>
    );
}

export default MiniWidgets;
